import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core'

@Component({
  selector: 'bgo-hero-call-to-action',
  templateUrl: './hero-call-to-action.component.html',
  styles: [':host { display: inline-block; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeroCallToActionComponent {
  @Input() type: 'primary' | 'secondary' = 'primary'
  @Input() anchor?: string
  @Input() routerLink?: string
  @Output() callToActionClick = new EventEmitter<void>()
}
